import { useI18n } from '@change-corgi/core/react/i18n';

import { useBusinessPageData } from 'src/app/pages/about/business/pageContext';

type Result = ModelHookResult<{
	title: string;
	description: string;
}>;

export function usePageMeta(): Result {
	const { translate } = useI18n();
	const {
		data: { title },
	} = useBusinessPageData();

	const description = translate('fe.pages.about_business_model.description');

	return {
		data: {
			title,
			description,
		},
	};
}
